// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modal_modalWrapper__PLUBD","formcontrol":"modal_formcontrol__knRDe","buttonModal":"modal_buttonModal__1Bdm+"};